class HeroBannerSlider extends HTMLElement {
  connectedCallback() {
    this._track = this.querySelector('.hero-banner-track');
    this._slides = Array.from(this.querySelectorAll('.hero-banner-slide'));
    this._dots = Array.from(this.querySelectorAll('.hero-banner-dot'));
    this._counter = this.querySelector('.hero-banner-counter-current');
    this._index = 0;
    this._timer = null;

    if (this._slides.length <= 1) return;

    this._dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this._goTo(i);
        this._resetAutoplay();
      });
    });

    this._setupSwipe();
    this._startAutoplay();
  }

  disconnectedCallback() {
    clearInterval(this._timer);
  }

  _goTo(index) {
    this._index = ((index % this._slides.length) + this._slides.length) % this._slides.length;
    this._track.style.transform = `translateX(-${this._index * 100}%)`;

    this._dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this._index);
    });

    if (this._counter) {
      this._counter.textContent = this._index + 1;
    }
  }

  _startAutoplay() {
    if (this.dataset.autoplay !== 'true') return;
    const speed = parseInt(this.dataset.speed, 10) || 5000;
    this._timer = setInterval(() => {
      this._goTo(this._index + 1);
    }, speed);
  }

  _resetAutoplay() {
    clearInterval(this._timer);
    this._startAutoplay();
  }

  _setupSwipe() {
    let startX = 0;
    let dragging = false;

    this.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    this.addEventListener('touchend', (e) => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        this._goTo(diff > 0 ? this._index + 1 : this._index - 1);
        this._resetAutoplay();
      }
    }, { passive: true });

    this.addEventListener('dragstart', (e) => e.preventDefault());

    this.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      dragging = true;
    });
    this.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      e.preventDefault();
    });
    this.addEventListener('mouseup', (e) => {
      if (!dragging) return;
      dragging = false;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 50) {
        this._goTo(diff > 0 ? this._index + 1 : this._index - 1);
        this._resetAutoplay();
      }
    });
    this.addEventListener('mouseleave', () => {
      dragging = false;
    });
  }
}

customElements.define('hero-banner-slider', HeroBannerSlider);
